import React from 'react';
import {Link} from 'react-router-dom';
import UltimasPaginasPublicacao from '../views/UltimasPaginasPublicacao';

export default class BoxPublicacoes extends React.Component {
  state = {
    id: undefined
  }

  jaAprovada () {
    this.props.publicacoes.map(publicacao => {
      publicacao.paginas.map(pagina => {
        if (pagina.comentarios.length > 0) {
          return true;
        }
      })
    });
    return false;
  }

  componentWillMount () {
    if (this.state.id === undefined) { 
      this.setState({id: this.props.pubId});
    }
  }

  getUrlImg () {
    let tipo = this.props.tipo;
    switch (tipo) {
      case "paginacao":
        return "./images/icons-aprov/CONVITE.png";
      case "capa-dura":
        return "./images/icons-aprov/CAPA-DURA.png";
      case "embalagens":
        return "./images/icons-aprov/EMBALAGEM.png";
      case "encarte":
        return "./images/icons-aprov/ENCARTE.png";
      case "convite-simples":
        return "./images/icons-aprov/CONVITE-SIMPLES.png";
      case "senha-de-entrada":
        return "./images/icons-aprov/SENHA.png";
      case "missal":
        return "./images/icons-aprov/MISSAL.png";
      case "outros-produtos":
        return "./images/icons-aprov/OUTROS-PRODUTOS.png";
      case "personalizadas":
        return "./images/icons-aprov/OUTROS-PRODUTOS.png";
      default:

    }
  }

  _renderBloco () {
    return (
      <div className="small-box bg-aqua" style={this.props.renderToFechamento && this.props.publicacoes[0].status === "fechado" ? {filter: "grayscale(.9)"} : {}}>
        <div className="inner" style={{position:"relative",zIndex:2}}>
          <h2 style={{zIndex: 1, color: "#fff", WebkitTextStrokeWidth: "1px", WebkitTextStrokeColor: "rgb(150, 150, 150)", textShadow: "1px 1px rgb(0, 192, 239)", fontWeight: 700}}>{this.props.titulo}</h2>
        </div>
        <div className="icon" style={{zIndex:1}}>
          <img src={this.getUrlImg()} style={{height: 50, marginBottom: 20}}></img>
        </div>
        <div className="small-box-footer" style={{background:"#0000006e"}}>
          {this.props.publicacoes.length > 0 ? `Publicado ${new Date(this.props.publicacoes[0].dataPublicacao).toLocaleString()}` : "Não há publicações"} &nbsp;&nbsp;
          <i className="fa fa-arrow-circle-right"></i>
        </div>
      </div>
    );
  }

  _renderBotaoImprimir () {
    return (
      <div style={{textAlign: "center", marginTop: 5}}>
        <i className="fa fa-print fa-lg" title="Imprimir" style={{cursor: "pointer", backgroundColor: "#ecf0f5", borderRadius: 20, color: "rgba(0, 0, 0, 0.85)", padding: 10}} onClick={()=>{
          let janela = window.open('', 'Impressão');
          janela.document.write('<html><head><title>Impressão</title><link id="link" rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css" integrity="sha384-BVYiiSIFeK1dGmJRAkycuHAHRg32OmUcww7on3RYdg4Va+PmSTsz/K68vbdEjh4u" crossorigin="anonymous"></head><body>');
          janela.document.write(document.querySelector(`#content${this.props.tipo}`).innerHTML);
          janela.document.write('</body></html>');
          janela.print();
        }}> IMPRIMIR</i>
        <div id={`content${this.props.tipo}`} style={{display: "none"}}>
          <UltimasPaginasPublicacao lastId={this.props.id} lastTipo={this.props.tipo}/>
        </div>
      </div>
    );
  }

  render () {
    let btn = "",
      texto = "";
    switch (this.props.publicacoes[0].status) {
      case "aprovado com correções":
        btn = "btn-success";
        texto = "Aprovada com correções";
        break;
      case "aprovado":
        btn = "btn-success";
        texto = "Aprovada";
        break;
      case "aguardando": 
        btn = "btn-warning";
        texto = "Nova publicação";
        break;
      case "fechado": 
        btn = "btn-danger";
        texto = "Publicação fechada";
        break;
      default: 
        btn = "btn-warning";
        texto = "Nova publicação";
    }
    return (
      <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12" style={{marginBottom: 10}}>
        {
          this.props.renderToFechamento ?
            this._renderBloco()
          : <Link onClick={this.props.publicacoes.length === 0 ? (event) => event.preventDefault() : null} to={`/contrato/${this.props.id}/${this.props.tipo ? this.props.tipo : ""}`} target="_blank">
              {this._renderBloco()}
            </Link>
        }
        <div style={{marginTop: -15, textAlign:"center"}} className={`btn-flat btn-block btn-xs ${btn}`}>{texto}</div>
        {
          !this.props.renderToFechamento ?
            this._renderBotaoImprimir()
          : null
        }
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/BoxPublicacoes.js